<template>
  <div class="goods-spec-image-main">
    <el-divider></el-divider>
    <div class="d-flex align-items-center">
      <span style="font-size: 14px; color: #606266">
        {{ title || '--' }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <div>
        <el-upload
          ref="uploader"
          multiple
          action="#"
          :show-file-list="false"
          :on-change="onGoodsImageChange"
          :auto-upload="false"
          accept=".jpeg,.jpg,.png,.gif"
        >
          <el-button class="ml-2" style="font-size: 14px;" type="text">
            {{ '上传图片' }}
          </el-button>
        </el-upload>
      </div>
    </div>
    <el-divider></el-divider>
    <GoodsImageList
      :data="data"
      @imageCheck="(e) => $emit('imageCheck', e)"
      @imageDel="(e) => $emit('imageDel', e)"
    />
  </div>
</template>
<script>
import GoodsImageList from '../../../goods-image-list'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    title: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    orderGoodsSpecCode: { type: String, default: '' },
    data: { type: Array, default: () => [] },
  },
  components: { GoodsImageList },
  data() {
    return {
      listGoodsSpecImage: [],
      uploadFileMaxLimit: 10,
    }
  },
  methods: {
    onGoodsImageChange(file) {
      const $uploader = this.$refs.uploader
      const uploader = $uploader.$el.querySelectorAll('input')[0]

      const listFile = uploader.files
      const fileCount = listFile.length

      if (fileCount > this.uploadFileMaxLimit) {
        const msg = `当前限制选择 ${this.uploadFileMaxLimit} 张图片，本次选择了 ${fileCount} 张图片`
        this.$message.warning(msg)
        this.clearFiles()
        throw new Error(msg)
      }

      this.listGoodsSpecImage.push(file)
      if (this.listGoodsSpecImage.length !== fileCount) return false
      this.upload()
    },
    async upload() {
      if (!this.listGoodsSpecImage || !this.listGoodsSpecImage.length) {
        this.$message.warning('请选择您需要上传的图片！')
        return
      }

      this.loadingOpen()
      const listImage = await this.uploadImages()
      if (listImage.includes(null)) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        this.clearFiles()
        return
      }

      const params = {
        orderGoodsCode: this.orderGoodsCode,
        orderGoodsSpecCode: this.orderGoodsSpecCode,
        listImage,
      }
      const res = await this.$api
        .orderGoodsSpecImageUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      this.clearFiles()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('reload')
    },
    uploadImages() {
      if (!this.listGoodsSpecImage || !this.listGoodsSpecImage.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listGoodsSpecImage.map((image) => {
        return this.$api
          .SYS_UPLOAD(image.raw)
          .then((res) => ({
            originImageCode: res.body.fileId,
            originImageUrl: res.body.url,
            originImageSpec: image.raw.type,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
    clearFiles() {
      this.$refs.uploader.clearFiles()
      this.listGoodsSpecImage = []
    },
  },
}
</script>

<style lang="scss" scoped>
.el-divider.el-divider--horizontal {
  margin: 5px 0;
}
::v-deep .el-card__body {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
